import gql from 'graphql-tag'

export const LOGGING = gql`
  mutation CreateUserActionsLog($input: CreateUserActionsLog!) {
    createUserActionsLog(input: $input) {
      isSuccessful
    }
  }
`

export const GET_USER_LOGS = gql`
  query UserActionsLogs($filter: GetUserActionsLogs) {
    userActionsLogs(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      userActionsLogs {
        data {
          companyId
          userId
          activityOn
          activity
          path
          component
          email
          tabName
          userRole
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`
